<template>
  <el-dialog :visible.sync="visibleSync" title="Thông tin lý do phúc khảo" :append-to-body="true" :modal-append-to-body="true"
    width="600px" :show-close="true" :close-on-click-modal="true" :close-on-press-escape="true" :modal="!imageDetailVisible"
    @close="closeModal">
    <div class="appeal-reason-content">
      <!-- Hình ảnh mô tả lỗi -->
      <div class="section mb-4">
        <h6 class="section-title mb-3">
          Hình ảnh mô tả lỗi
        </h6>
        <div class="images-grid" v-if="displayData && displayData.images && displayData.images.length > 0">
          <div v-for="(image, index) in displayData.images" :key="index" class="image-item"
            @click="openImageDetail(image)">
            <img :src="image.thumbnail || image.url" :alt="image.description || 'Hình ảnh mô tả lỗi'"
              class="image-thumbnail" @error="handleImageError" @load="handleImageLoad" />
            <div class="image-overlay">
              <i class="fa fa-search-plus"></i>
            </div>
          </div>
        </div>
        <div v-else class="no-images">
          <i class="fa fa-image text-muted" style="font-size: 3rem;"></i>
          <p class="text-muted mt-2">Không có hình ảnh</p>
        </div>
      </div>

      <!-- Lý do phúc khảo -->
      <div class="section">
        <h6 class="section-title mb-3">
          Lý do phúc khảo
        </h6>
        <div class="reason-content">
          <p class="reason-text">{{ (displayData && displayData.reason) || 'Không có thông tin lý do phúc khảo' }}</p>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer d-flex justify-content-end">
      <button class="mt-2 btn btn-primary font-weight-bold" @click="closeModal">
        Đóng
      </button>
    </div>

    <!-- Image Detail Modal -->
    <image-detail-modal :key="selectedImage && selectedImage.id" v-if="imageDetailVisible" :visible.sync="imageDetailVisible" :image="selectedImage"
      :images="(displayData && displayData.images) || []"
      :current-index="selectedImage && displayData && displayData.images ? displayData.images.findIndex(img => img.id === selectedImage.id) : 0"
      @image-changed="onImageChanged" />
  </el-dialog>
</template>

<script>
import ImageDetailModal from './ImageDetailModal.vue';

export default {
  name: 'AppealReasonModal',
  components: {
    ImageDetailModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    appealData: {
      type: Object,
      default: () => ({
        images: [],
        reason: ''
      })
    },
    homeworkId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      visibleSync: this.visible,
      imageDetailVisible: false,
      selectedImage: null
    };
  },
  computed: {
    displayData() {
      const data = this.appealData;
      return data || {
        images: [],
        reason: '',
        id: null,
        submitted_at: null,
        status: null,
        submitted_by: null,
        submitted_by_id: null,
        category: null,
        priority: null
      };
    }
  },
  mounted() {
  },
  watch: {
    visible(v) {
      this.visibleSync = v;
      if (v) {
        // Reset data khi mở modal
        this.selectedImage = null;
        this.imageDetailVisible = false;
      }
    },
    visibleSync(v) {
      this.$emit('update:visible', v);
    }
  },
  methods: {
    closeModal() {
      this.visibleSync = false;
    },

    openImageDetail(image) {
      if (image && typeof image === 'object') {
        this.selectedImage = image;
        this.imageDetailVisible = true;
      } else {
        console.warn('Invalid image object provided to openImageDetail');
      }
    },

    onImageChanged(index) {
      if (this.displayData && this.displayData.images && this.displayData.images[index]) {
        this.selectedImage = this.displayData.images[index];
      }
    },

    handleImageError(event) {
    },
    handleImageLoad(event) {
    }
  }
};
</script>

<style lang="scss" scoped>
.appeal-reason-content {
  .section {
    .section-title {
      color: #495057;
      font-weight: 600;
      margin-bottom: 1rem;
    }
  }

  .images-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 1rem;
    margin-bottom: 1rem;

    .image-item {
      position: relative;
      cursor: pointer;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);

        .image-overlay {
          opacity: 1;
        }
      }

      .image-thumbnail {
        width: 100%;
        height: 120px;
        object-fit: cover;
        display: block;
        background: #f8f9fa;
        border: 1px solid #dee2e6;
      }

      .image-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.3s ease;

        i {
          color: white;
          font-size: 1.5rem;
        }
      }
    }
  }

  .no-images {
    text-align: center;
    padding: 2rem;
    background: #f8f9fa;
    border-radius: 8px;
    border: 2px dashed #dee2e6;
  }

  .reason-content {
    background: #f8f9fa;
    padding: 1rem;
    border-radius: 8px;

    .reason-text {
      margin: 0;
      line-height: 1.6;
      color: #495057;
      white-space: pre-line;
    }
  }
}

// Responsive design
@media (max-width: 768px) {
  .images-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)) !important;
    gap: 0.75rem !important;
  }

  .image-item .image-thumbnail {
    height: 100px !important;
  }
}
</style>
